import DailyPortalOracleDeck from '../../components/oracle/DailyPortalOracleDeck';

const DailyPortalOraclePage = ({lang = 'es'}) => {

  return (
    <div className="bg-gray-900 min-h-screen pt-16">
      <DailyPortalOracleDeck lang={lang} />
    </div>
  );
};

export default DailyPortalOraclePage;